import { FC } from 'react'

import { routes } from 'commons/constants/routes'
import { Link } from 'ui/components'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'

import { SetupOnboardingDocumentsButton } from '../SetupOnboardingDocumentsButton'
import { ApplicationControlsProps } from './ApplicationControlsProps'
import {
  AdvancePastDocs,
  ApproveAllDocuments,
  ApproveApplication,
  ArchiveReviewFormUpload,
  ComitteeFormUpload,
  ComplianceReviewFormUpload,
  CreditReviewFormUpload,
  FinalReviewFormUpload,
  FinalizeApplication,
  MartinHoodReviewFormUpload,
  RevertToDocumentRequestPending,
  RevertToRFIPending,
  SendDocumentRequest,
  TimeLine
} from './components'

export const ApplicationControls: FC<ApplicationControlsProps> = (props) => {
  const { application, isFinalizing, onFinalizeApplication } = props
  const {
    applicationID,
    enableRevertToRFIPending,
    enableRevertToDocumentRequestPending,
    progressTimelineStatus,
    enableApproveAllDocuments,
    enableAdvancePastDocs,
    enableApproveApplication,
    enableComitteeFormUpload,
    enableFinalReviewFormUpload,
    formNameFinalReview,
    enableArchiveFormUpload,
    formNameArchive,
    enableMartinHoodReviewFormUpload,
    enableCreditReviewFormUpload,
    enableComplianceReviewFormUpload,
    enableSendDocumentRequest,
    enableViewChanges,
    showOnboardingDocuments,
    enableSetupOnboardingDocuments,
    enableAcknowledgeChanges,
    enableFinalizeApplication
  } = application

  return (
    <>
      <ButtonGroup margin="small">
        {enableRevertToRFIPending && <RevertToRFIPending application={application} />}
        {enableRevertToDocumentRequestPending && <RevertToDocumentRequestPending application={application} />}
      </ButtonGroup>
      {progressTimelineStatus && <TimeLine status={progressTimelineStatus} />}
      <ButtonGroup margin="small">
        {enableApproveAllDocuments && <ApproveAllDocuments application={application} />}
        {enableAdvancePastDocs && <AdvancePastDocs application={application} />}
        {enableApproveApplication && <ApproveApplication application={application} />}
        {enableComitteeFormUpload && <ComitteeFormUpload application={application} />}
        {enableFinalReviewFormUpload && <FinalReviewFormUpload application={application} title={formNameFinalReview} />}
        {enableArchiveFormUpload && <ArchiveReviewFormUpload application={application} title={formNameArchive} />}
        {enableMartinHoodReviewFormUpload && <MartinHoodReviewFormUpload application={application} />}
        {enableCreditReviewFormUpload && <CreditReviewFormUpload application={application} />}
        {enableComplianceReviewFormUpload && <ComplianceReviewFormUpload application={application} />}
        {enableSendDocumentRequest && <SendDocumentRequest application={application} />}
        {enableViewChanges && (
          <Link to={routes.bank.application.warningsDetails} params={{ id: applicationID }}>
            <Button face="secondary">View Changes</Button>
          </Link>
        )}
        {showOnboardingDocuments && (
          <SetupOnboardingDocumentsButton
            applicationId={applicationID}
            enableSetupOnboardingDocuments={enableSetupOnboardingDocuments}
          />
        )}
        {enableAcknowledgeChanges && (
          <Link to={routes.bank.application.warningsDetails} params={{ id: applicationID }}>
            <Button face="primary">View and Acknowledge</Button>
          </Link>
        )}
        {enableFinalizeApplication && (
          <FinalizeApplication isFinalizing={isFinalizing} onFinalizeApplication={onFinalizeApplication} />
        )}
      </ButtonGroup>
    </>
  )
}
